/**
 * Created by Prarsol on 2016/5/16.
 */
import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Icon, Input, InputNumber, Modal, Select, Spin, Switch, TreeSelect, Upload} from 'antd';
import {
  CLIENT_ID,
  DEFAULT_MAX_ORD,
  ROOM_ALLOW_SVC,
  ROOM_CAPACITY,
  ROOM_NEED_AUDIT,
  SEMICOLON,
  SIGN_TYPE
} from '../../utils/constants.js';
import './RoomEditor.less';
import {CHINESE, ROLES_KEY} from '../../utils/constants';

const Option = Select.Option;

//会议室管理
class RoomEditor extends React.Component {
  constructor(props) {
    super(props);
    const {currentUser} = props;
    RoomEditor.roomDefaultState.adminUserId =
      currentUser.roleKey === ROLES_KEY.room_admin ? currentUser.userId : '';
    this.state = Object.assign({}, RoomEditor.roomDefaultState, {
      loading: false
    });
  }

  componentWillMount() {
    let {roomInfo, allAreaDataNoPermission, currentUser} = this.props;
    let allAreaData = allAreaDataNoPermission;
    let parkId = '';
    if (roomInfo.zoneId) {
      allAreaData.child &&
      allAreaData.child.map(a => {
        if (a.child && a.child.some(c => c.id == roomInfo.zoneId)) {
          parkId = a.id;
        }
      });
    } else {
      parkId = roomInfo.parkId ? roomInfo.parkId : '';
    }
    let floorData = [];
    if (parkId && allAreaData && allAreaData.child) {
      allAreaData.child.map(zone => {
        if (zone.id == parkId) {
          floorData = zone.child;
        }
      });
    }
    let logoFileList = [];
    if (roomInfo.logo) {
      roomInfo.logo.split(';').map(fileUrl => {
        logoFileList.push({
          uid: `meeting_${Math.random()}`,
          url: fileUrl,
          name: 'xxx',
          status: 'done'
        });
      });
    }
    roomInfo.logoFileList = logoFileList;
    this.setState(
      Object.assign({}, roomInfo, {
        floorData,
        parkId
      })
    );
  }

  componentWillReceiveProps(props) {
    let {roomInfo, allAreaDataNoPermission} = props;
    let allAreaData = allAreaDataNoPermission;
    let parkId = '';
    if (roomInfo.zoneId) {
      allAreaData.child &&
      allAreaData.child.map(a => {
        if (a.child && a.child.some(c => c.id == roomInfo.zoneId)) {
          parkId = a.id;
        }
      });
    } else {
      parkId = roomInfo.parkId ? roomInfo.parkId : '';
    }
    let floorData = [];
    if (parkId && allAreaData && allAreaData.child) {
      allAreaData.child.map(zone => {
        if (zone.id == parkId) {
          floorData = zone.child;
        }
      });
    }
    let logoFileList = [];
    if (roomInfo.logo) {
      roomInfo.logo.split(';').map(fileUrl => {
        logoFileList.push({
          uid: `meeting_${Math.random()}`,
          url: fileUrl,
          name: 'xxx',
          status: 'done'
        });
      });
    }
    roomInfo.logoFileList = logoFileList;
    this.setState(
      Object.assign({}, roomInfo, {
        floorData,
        parkId
      })
    );
  }

  checkData = roomInfo => {
    const {intl} = this.props;
    if (roomInfo.name == null || roomInfo.name === '') {
      Modal.warning({
        content: intl.formatMessage({id: "room_editor_check_name"}),
        okText: intl.formatMessage({id: "room_editor_check_okText"})
      });
      return false;
    }
    if (roomInfo.nameEn == null || roomInfo.nameEn === '') {
      Modal.warning({
        content: intl.formatMessage({id: "room_editor_check_nameEn"}),
        okText: intl.formatMessage({id: "room_editor_check_okText"})
      });
      return false;
    }
    const ordReg = /^[0-9]*$/;
    if (roomInfo.ord) {
      if (
        isNaN(roomInfo.ord) ||
        !ordReg.test(roomInfo.ord) ||
        Number(roomInfo.ord) <= 0
      ) {
        Modal.warning({content: intl.formatMessage({id: "room_editor_check_ord_min"})});
        return;
      } else if (roomInfo.ord.length > 6) {
        Modal.warning({content: intl.formatMessage({id: "room_editor_check_ord_max"})});
        return;
      }
    } else {
      roomInfo.ord = DEFAULT_MAX_ORD; //把没有设置序号的设置为默认最大序号，方便后台排序
    }
    roomInfo.doorCode = String(roomInfo.doorCode).trim();
    if (!roomInfo.zoneId) {
      Modal.warning({
        content: intl.formatMessage({id: "room_editor_check_zone"}),
        okText: intl.formatMessage({id: "room_editor_check_okText"})
      });
      return false;
    }
    if (!roomInfo.email) {
      Modal.warning({
        content: intl.formatMessage({id: "room_editor_check_email"}),
        okText: intl.formatMessage({id: "room_editor_check_okText"})
      });
      return false;
    }
    const emailReg = /^[a-zA-Z0-9_\-\.]+@[a-zA-Z0-9_\-\.]+\.[a-zA-Z]{2,3}$/;
    if (!emailReg.test(roomInfo.email)) {
      Modal.warning({
        content: intl.formatMessage({id: "room_editor_check_emailReg"}),
        okText: intl.formatMessage({id: "room_editor_check_okText"})
      });
      return false;
    }
    if (!roomInfo.minNumber) {
      Modal.warning({
        content: intl.formatMessage({id: "room_edit_wrong_num"}),
        okText: intl.formatMessage({id: "modal_manage_btn_ok"})
      });
      return false;
    }
    if (!roomInfo.maxNumber) {
      Modal.warning({
        content: intl.formatMessage({id: "room_editor_check_maxNumber"}),
        okText: intl.formatMessage({id: "room_editor_check_okText"})
      });
      return false;
    }
    if (Number(roomInfo.maxNumber) < Number(roomInfo.minNumber)) {
      Modal.warning({
        content: intl.formatMessage({id: "room_editor_check_minNumber"}),
        okText: intl.formatMessage({id: "room_editor_check_okText"})
      });
      return false;
    }
    if (!roomInfo.adminUserId) {
      Modal.warning({
        content: intl.formatMessage({id: "room_editor_check_adminUserId"}),
        okText: intl.formatMessage({id: "room_editor_check_okText"})
      });
      return false;
    }
    return true;
  };
  save = () => {
    let roomInfo = {
      ...this.state,
      ...{
        deviceIds: this.state.deviceIds.toString().replace(/,/g, ';'),
        roomId: this.state.id
      }
    };
    delete roomInfo.loading;
    //处理会议室图片和位置
    let logo = '';
    if (roomInfo.logoFileList && roomInfo.logoFileList.length > 0) {
      roomInfo.logoFileList.map(file => {
        if (file.response && file.response.result == 0) {
          let fileUrl = file.response.list[0].fileUrl;
          if (logo) {
            logo += `;${fileUrl}`;
          } else {
            logo += `${fileUrl}`;
          }
        } else if (file.uid.startsWith('meeting_')) {
          if (logo) {
            logo += `;${file.url}`;
          } else {
            logo += `${file.url}`;
          }
        }
      });
    }
    roomInfo.logo = logo;
    //检查数据
    let flg = this.checkData(roomInfo);
    if (flg) {
      if (roomInfo.capacity === ROOM_CAPACITY.immediate) {//即占即用会议室不需要如下属性
        roomInfo.allowSvc = 0;
        roomInfo.audit = 0;
      }
      this.setState({loading: true});
      new Promise((resolve, reject) => {
        this.props.saveHandle({roomInfo, resolve, reject});
      }).then(
        () => {
          this.setState({loading: false});
        },
        () => {
          this.setState({loading: false});
        }
      );
    }
  };
  getUploadLogo = info => {
    let {fileList} = info;
    let {file} = info;
    if (file.name.indexOf('&') > -1) {
      file.name = file.name.replace(/&/g, '$');
    }
    if (file.status === 'done') {
      if (file.response && file.response.result === 0) {
        let fileUrl = file.response.list[0].fileUrl;
        this.setState({logo: fileUrl});
      }
    } else if (info.file.status === 'error') {
      Modal.error({
        content: this.props.intl.formatMessage({id: 'image_upload_error'})
      });
    }
    fileList = fileList.slice(-1);
    this.setState({logoFileList: fileList});
  };

  render() {
    const {
      show,
      meetingManagers,
      deviceInfo,
      allAreaDataNoPermission,
      allCompanyData,
      allCompanyDataChild,
      allCompanyDataParent,
      allCompanyDataName,
      intl,
      currentUser,
      locale,
      meetingPolicy = {cmmaMeetingState: 1, showMeetingSvc: 0, visibleSwitch: 1,billingSwitch: 1}
    } = this.props;
    let allAreaData = allAreaDataNoPermission;
    const {roomDeviceList} = deviceInfo;
    let meetingMangerOpts = [];
    meetingManagers.map(item => {
      meetingMangerOpts.push(
        <Option key={item.userId}>
          {item.firstName + (item.givenName ? item.givenName : '')}
        </Option>
      );
    });

    const organizeTree = (depts = []) => {
      if (depts.length > 0) {
        depts.map(dept => {
          dept.children = dept.depts;
          dept.key = dept.id + '';
          dept.value = dept.id + '';
          dept.label = dept.name;
          if (dept.children.length > 0) {
            organizeTree(dept.children);
          }
        });
      }
    };

    organizeTree(allCompanyData ? [allCompanyData] : []);

    const logoFileProps = {
      name: 'fileUpload',
      listType: 'picture',
      className: 'logo-uploader',
      action: `/storage/file/savefile?lang=zh_CN&token=${sessionStorage.getItem(
        'token'
      )}&fromType=${CLIENT_ID}`,
      onChange: this.getUploadLogo,
      headers: {token: sessionStorage.getItem('token')},
      multiple: false,
      fileList: this.state.logoFileList,
      showUploadList: false,
      beforeUpload: fileList => {
      }
    };
    const BiTianDiv = (<div className="bitian_div"><span className="bitian_span">*</span></div>);
    let leftClassName = intl.locale === CHINESE ? 'left' : 'left-en';
    return (<Modal wrapClassName="room_editor modal-close-header"
                   title={this.state.id > 0 ? <FormattedMessage id="room_edit_modal_title"/> :
                     <FormattedMessage id="room_add_modal_title"/>}
                   maskClosable={false}
                   visible={show}
                   footer={null}
                   onCancel={() => {
                     this.setState(Object.assign({}, RoomEditor.roomDefaultState));
                     this.props.cancelHandle();
                   }}
                   width={intl.locale === CHINESE ? 818 : 900}>
        <Spin spinning={this.state.loading}>
          <div className="room_editor_content">
            <div className="row">
              <div className={leftClassName}>{BiTianDiv}<FormattedMessage id="room_edit_room_name"/> :</div>
              <div className="right">
                <Input type="text" maxLength="24" value={this.state.name} onChange={(e) => {
                  this.setState({name: e.target.value});
                }} placeholder={intl.formatMessage({id: "room_edit_room_name"})}/>
              </div>
            </div>
            <div className="row">
              <div className={leftClassName}>{BiTianDiv}<FormattedMessage id="room_edit_room_nameEn"/> :</div>
              <div className="right">
                <Input type="text" maxLength="24" value={this.state.nameEn} onChange={(e) => {
                  this.setState({nameEn: e.target.value});
                }} placeholder={intl.formatMessage({id: "room_edit_room_nameEn"})}/>
              </div>
            </div>
            <div className="row">
              <div className={leftClassName}><FormattedMessage id="room_edit_room_code"/> :</div>
              <div className="right"><Input value={this.state.doorCode} onChange={(e) => {
                let value = e.target.value;
                this.setState({doorCode: value});
              }} placeholder={intl.formatMessage({id: "room_edit_room_code"})}/></div>
            </div>
            <div className="row">
              <div className={leftClassName}>{BiTianDiv}<FormattedMessage id="room_edit_belong_area"/> :</div>
              <div className="right">
                <div className="area_sel">
                  <Select placeholder={intl.formatMessage({id: 'room_edit_area'})} value={`${this.state.parkId}`}
                          onChange={(value) => {
                            let floorData = [];
                            if (allAreaData && allAreaData.child) {
                              allAreaData.child.map(zone => {
                                if (zone.id == value && zone.child) {
                                  floorData = zone.child;
                                }
                              });
                            }
                            this.setState({floorData, parkId: value, zoneId: ''});
                          }}>
                    {allAreaData && allAreaData.child && allAreaData.child.map(zone => {
                      return <Option value={`${zone.id}`} key={`${zone.id}`}>{zone.name}</Option>;
                    })}
                  </Select></div>
                <div className="separator"/>
                <div className="area_sel">
                  <Select placeholder={intl.formatMessage({id: 'room_edit_floor'})}
                          value={`${this.state.zoneId}`}
                          onChange={(value) => {
                            this.setState({zoneId: value})
                          }}>
                    {this.state.floorData && this.state.floorData.map(fd => {
                      return <Option value={`${fd.id}`} key={`${fd.id}`}>{fd.name}</Option>
                    })}
                  </Select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className={leftClassName}>{BiTianDiv}<FormattedMessage id="room_edit_email"/> :</div>
              <div className="right"><Input maxLength="50" value={this.state.email} onChange={(e) => {
                let value = e.target.value;
                this.setState({email: value});
              }} placeholder={intl.formatMessage({id: 'room_edit_email'})}/></div>
            </div>
            <div className="row">
              <div className={leftClassName}>{BiTianDiv}<FormattedMessage id="room_edit_people_number"/> :</div>
              <div className="right" style={{display: "inline-flex"}}>
                <div style={{width: "80px", display: "inline-block"}}>
                  <Input value={this.state.minNumber}
                         onChange={(e => {
                           if (!isNaN(e.target.value) && Number(e.target.value) <= 10000) {
                             if (Number(e.target.value) === 0) {
                               this.setState({minNumber: ""})
                             } else {
                               this.setState({minNumber: Number(e.target.value)})
                             }
                           }
                         })}/>
                </div>
                <div style={{width: "30px", display: "inline-block", textAlign: "center"}}>—</div>
                <div style={{width: "80px", display: "inline-block"}}>
                  <Input value={this.state.maxNumber}
                         onChange={e => {
                           if (!isNaN(e.target.value) && Number(e.target.value) <= 10000) {
                             if (Number(e.target.value) === 0) {
                               this.setState({maxNumber: ""})
                             } else {
                               this.setState({maxNumber: Number(e.target.value)})
                             }
                           }
                         }}/>
                </div>
                &nbsp;<FormattedMessage id="room_edit_person"/>
                {meetingPolicy.billingSwitch === 1 && <div>
                  <div style={{display: "inline-block", marginLeft: "59px", width: "105px"}}><FormattedMessage
                    id="room_edit_cost"/>:
                  </div>
                  <div style={{display: "inline-block", width: "70px", marginLeft: "15px"}}>
                    <InputNumber value={this.state.rates} onChange={value => {
                      this.setState({rates: value});
                    }} min={0}/>
                  </div>
                  <div style={{display: "inline-block", marginLeft: "15px"}}>
                    <FormattedMessage id="room_edit_unit_price"/>
                  </div>
                </div>}
              </div>
            </div>
            <div className="row">
              <div className={leftClassName}>{BiTianDiv}<FormattedMessage id="room_edit_room_type"/> :</div>
              <div className="right">
                <div className="room_category_sel">
                  <Select value={`${this.state.capacity}`}
                          placeholder={intl.formatMessage({id: 'room_edit_placeholder_room_type'})}
                          onChange={value => {
                            if (Number(value) === ROOM_CAPACITY.immediate) {
                              this.setState({capacity: Number(value), isOpenHW: 1});
                            } else if (Number(value) === ROOM_CAPACITY.webex) {
                              this.setState({capacity: Number(value), sign: SIGN_TYPE.no});
                            } else {
                              this.setState({capacity: Number(value)});
                            }
                          }}>
                    <Option key={ROOM_CAPACITY.common} value={String(ROOM_CAPACITY.common)}><FormattedMessage
                      id="room_types_common"/></Option>
                    <Option key={ROOM_CAPACITY.webex} value={String(ROOM_CAPACITY.webex)}><FormattedMessage
                      id="room_types_webex"/></Option>
                    <Option key={ROOM_CAPACITY.exchange} value={String(ROOM_CAPACITY.exchange)}><FormattedMessage
                      id="room_types_exchange"/></Option>
                    <Option key={ROOM_CAPACITY.google_calendar}
                            value={String(ROOM_CAPACITY.google_calendar)}><FormattedMessage
                      id="room_types_google_calendar"/></Option>
                    {
                      meetingPolicy.cmmaMeetingState === 1 &&
                      <Option key={ROOM_CAPACITY.cisco_cmma} value={String(ROOM_CAPACITY.cisco_cmma)}><FormattedMessage
                        id="room_types_cisco_cmma"/></Option>
                    }
                    <Option key={ROOM_CAPACITY.immediate}
                            value={String(ROOM_CAPACITY.immediate)}><FormattedMessage
                      id="room_types_immediate"/></Option>
                  </Select>
                </div>
              </div>
            </div>
            {1 == meetingPolicy.showMeetingSvc && this.state.capacity !== ROOM_CAPACITY.immediate ? (
              <div className="row">
                <div className={leftClassName}>
                  {BiTianDiv}
                  <FormattedMessage id="room_edit_allow_apply_svc"/> :
                </div>
                <div className="right">
                  <div>
                    <Switch
                      checked={this.state.allowSvc === ROOM_ALLOW_SVC.yes}
                      onChange={checked => {
                        this.setState({
                          allowSvc: checked
                            ? ROOM_ALLOW_SVC.yes
                            : ROOM_ALLOW_SVC.no
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            ) : null}
            <div className="row">
              <div className={leftClassName}>
                <FormattedMessage id="room_manage_organization"/> :
              </div>
              <div className="right">
                <div className="company_sel">
                  <TreeSelect
                    multiple
                    allowClear
                    labelInValue={true}
                    treeCheckable={true}
                    treeCheckStrictly={true}
                    treeNodeFilterProp="name"
                    dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                    value={this.getCompanyTreeValue(this.state.company)}
                    treeData={allCompanyData ? [allCompanyData] : []}
                    onChange={(value, label, extra) => {
                      this.companyTreeSelectOnChange(
                        value,
                        extra,
                        allCompanyData,
                        allCompanyDataChild,
                        allCompanyDataParent,
                        allCompanyDataName
                      );
                    }}
                  />
                </div>
              </div>
            </div>
            {
              this.state.capacity !== ROOM_CAPACITY.immediate &&
              <div className="row">
                <div className={leftClassName}>
                  {BiTianDiv}
                  <FormattedMessage id="room_edit_sign_type"/> :
                </div>
                <div className="right">
                  <div className="sign_type_sel">
                    <Select
                      disabled={this.state.capacity == ROOM_CAPACITY.webex ? true : false}
                      value={`${this.state.sign}`}
                      onChange={value => {
                        this.setState({sign: value});
                      }}
                      placeholder={intl.formatMessage({
                        id: 'room_edit_placeholder_sign_type'
                      })}
                    >
                      <Option key={SIGN_TYPE.no} value={SIGN_TYPE.no}>
                        <FormattedMessage id="service_sign_noneed"/>
                      </Option>
                      <Option
                        key={SIGN_TYPE.anonymous}
                        value={SIGN_TYPE.anonymous}
                      >
                        <FormattedMessage id="service_sign_anonymous"/>
                      </Option>
                      <Option key={SIGN_TYPE.password} value={SIGN_TYPE.password}>
                        <FormattedMessage id="service_sign_password"/>
                      </Option>
                      {/*<Option key={SIGN_TYPE.inviteCode} value={SIGN_TYPE.inviteCode}><FormattedMessage*/}
                      {/*id="service_sign_Invitation"/></Option>*/}
                      {/*<Option key={SIGN_TYPE.qr} value={SIGN_TYPE.qr}><FormattedMessage id="service_sign_qr"/></Option>*/}
                      {/*<Option key={SIGN_TYPE.face} value={SIGN_TYPE.face}><FormattedMessage*/}
                      {/*id="service_sign_face"/></Option>*/}
                    </Select>
                  </div>
                </div>
              </div>
            }
            {meetingPolicy.visibleSwitch == 1 ? <div className="row">
              <div className={leftClassName}>
                {BiTianDiv}
                <FormattedMessage id="room_edit_usage"/> :
              </div>
              <div className="right">
                <div className="sign_type_sel">
                  <Switch
                    checked={this.state.visible === 0}
                    onChange={checked => {
                      this.setState({
                        visible: checked ? 0 : 1
                      });
                    }}
                  />
                </div>
              </div>
            </div> : null}
            {
              this.state.capacity !== ROOM_CAPACITY.immediate &&
              <div className="row">
                <div className={leftClassName}>
                  {BiTianDiv}
                  <FormattedMessage id="room_edit_need_audit"/> :
                </div>
                <div className="right">
                  <div className="sign_type_sel">
                    <Switch
                      checked={this.state.audit === ROOM_NEED_AUDIT.yes}
                      onChange={checked => {
                        this.setState({
                          audit: checked
                            ? ROOM_NEED_AUDIT.yes
                            : ROOM_NEED_AUDIT.no
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            }
            <div className="row">
              <div className={leftClassName}>
                {BiTianDiv}
                <FormattedMessage id="room_edit_room_manage"/> :
              </div>
              <div className="right">
                <div className="meeting_manager_sel">
                  <Select
                    mode="multiple"
                    placeholder={this.props.intl.formatMessage({
                      id: 'main_meeting_room_placeholder_manager'
                    })}
                    defaultValue={[]}
                    value={
                      this.state.adminUserId
                        ? this.state.adminUserId.split(SEMICOLON)
                        : []
                    }
                    onChange={arr => {
                      if (
                        currentUser.roleKey === ROLES_KEY.room_admin &&
                        !arr.some(val => val === currentUser.userId)
                      ) {
                        Modal.warning({
                          content: intl.formatMessage({
                            id: 'room_edit_admin_warning'
                          }),
                          okText: intl.formatMessage({id: 'dialog_btn_ok'})
                        });
                        return false;
                      }
                      this.setState({adminUserId: arr.join(SEMICOLON)});
                    }}
                  >
                    {meetingMangerOpts}
                  </Select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className={leftClassName}>
                <FormattedMessage id="room_edit_fixed_device"/> :
              </div>
              <div className="right">
                <div className="device_sel">
                  <Select
                    //dropdownStyle={{ maxHeight: 200, overflow: 'auto' }}
                    mode="multiple"
                    placeholder={intl.formatMessage({
                      id: 'room_edit_placeholder_fixed_device'
                    })}
                    value={
                      this.state.deviceIds
                        ? this.state.deviceIds.split(';')
                        : []
                    }
                    onChange={value => {
                      if (value.length > 5) {
                        Modal.warning({
                          content: intl.formatMessage({
                            id: 'room_edit_device_maximum'
                          }),
                          okText: intl.formatMessage({id: 'dialog_btn_ok'})
                        })
                      } else {
                        this.setState({
                          deviceIds: value.join(';')
                        })
                      }
                    }}
                  >
                    {roomDeviceList &&
                    roomDeviceList.map(fd => {
                      return (
                        <Option key={`${fd.id}`} value={`${fd.id}`}>
                          {locale == 'en_US' ? fd.nameEn : fd.name}
                        </Option>
                      );
                    })}
                  </Select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className={leftClassName}>
                <FormattedMessage id="room_edit_room_image"/> :
              </div>
              <div className="right">
                <div style={{display: 'inline-block'}}>
                  <Upload {...logoFileProps}>
                    {this.state.logo ? (
                      <img src={this.state.logo} alt="" className="logo"/>
                    ) : (
                      <Icon type="plus" className="logo-uploader-trigger"/>
                    )}
                  </Upload>
                </div>
              </div>
            </div>
            <div className="row">
              <div className={leftClassName}>
                <FormattedMessage id="room_edit_room_order"/> :
              </div>
              <div className="right">
                <Input
                  value={
                    this.state.ord === DEFAULT_MAX_ORD ? '' : this.state.ord
                  }
                  onChange={e => {
                    const reg = /^[0-9]*$/;
                    if (reg.test(e.target.value)) {
                      this.setState({ord: e.target.value});
                    }
                  }}
                  placeholder={intl.formatMessage({
                    id: 'room_edit_placeholder_room_order'
                  })}
                />
              </div>
            </div>
            <div className="row">
              <div className={leftClassName}>
                <FormattedMessage id="room_edit_open_hw"/> :
              </div>
              <div className="right">
                <Switch
                  disabled={this.state.viewOnly || this.state.capacity === ROOM_CAPACITY.immediate}
                  checked={this.state.isOpenHW == 1}
                  onChange={value => {
                    this.setState({isOpenHW: value ? 1 : 0});
                  }}
                />
              </div>
            </div>
          </div>
          <div className="meeting_modal_footer">
            <div
              className="device_button_cancel"
              onClick={() => {
                this.setState(Object.assign({}, RoomEditor.roomDefaultState));
                this.props.cancelHandle();
              }}
            >
              <FormattedMessage id="room_edit_cancel"/>
            </div>
            <div className="device_button_ok" onClick={this.save}>
              <FormattedMessage id="room_edit_ok"/>
            </div>
          </div>
        </Spin>
      </Modal>
    );
  }

  getCompanyTreeValue = company => {
    let companyTreeValue = [];
    if (!company) {
      return companyTreeValue;
    }
    let companyArr = company.split(';');
    companyArr.map(v => {
      companyTreeValue.push({value: v});
    });
    return companyTreeValue;
  };
  companyTreeSelectOnChange = (
    value,
    extra,
    allCompanyData,
    allCompanyDataChild,
    allCompanyDataParent,
    allCompanyDataName
  ) => {
    if (!extra.triggerValue) {
      //清空操作
      this.setState({companyTreeValue: [], company: '', companyNames: ''});
    } else {
      //选中或取消选中操作
      let check = new Set();
      let parent = allCompanyDataParent[extra.triggerValue];
      if (extra.checked) {
        parent.map(c => {
          check.add(c);
        });
      } else {
      }
      value.map(({value}) => {
        check.add(value);
      });
      let child = allCompanyDataChild[extra.triggerValue];
      child.map(c => {
        if (extra.checked) {
          check.add(c);
        } else {
          check.delete(c);
        }
      });
      let company = '';
      let companyNames = '';
      check.forEach(function (value) {
        if (company) {
          company += `;${value}`;
        } else {
          company += `${value}`;
        }
        if (companyNames) {
          companyNames += `;${allCompanyDataName[value]}`;
        } else {
          companyNames += `${allCompanyDataName[value]}`;
        }
      });
      this.setState({companyTreeValue: value, company, companyNames});
    }
  };
}

export default RoomEditor;

RoomEditor.roomDefaultState = {
  floorData: [],
  zoneId: '', //区域ID(默认为根区域)
  parkId: '', //楼层ID
  minNumber: '1',
  maxNumber: '10',
  company: '', //所属公司
  companyNames: '',
  logo: '',
  logoFileList: [],
  id: '0', //会议室ID(新增ID为0)
  name: '', //会议室名称*
  nameEn: '', //会议室英文名称
  creatorId: '', //创建者userId(带域信息,例如:zhangyi@wafersystems.com)*
  status: 0, //会议室使用状态(0.正常[默认],1.锁定)
  open: 0, //会议室共享状态(0.公开[默认],1.私有)
  sign: -1, //签到类型(-1.不签到[默认],0.匿名签到,1.安全签到)
  rest: 0, //茶歇类型(0.不支持[默认],1.支持)
  capacity: 0, //会议室类型(0.普通会议室[默认],1.WebEx会议室,2.Acano会议室,3.Exchange会议室,4.Domino|Notes会议室,5.Google Calendar会议室)
  seat: 0, //容纳人数(具体人数或人数范围[1:1-5人,2:6-10人,3:10人以上])
  email: '', //邮件(特殊类型会议室唯一标示)
  deviceIds: '', //设备ID(多设备以';'分隔)
  rates: 0, //会议室租用费率(单位:元/小时)
  telephone: '', //会议室电话
  intervalTime: 0, //会议间隔时间(单位:分钟)
  serviceIP: '', //第三方服务IP
  remark: '', //备注信息
  files: '', //会议室图片(File类型)
  lang: 'zh_CN', //语言(中文:zh/zh_CN,英文:en/en_US)
  typeDisabled: false, //页面标志，是否可选类型
  adminUserId: '',
  doorCode: '',
  ord: '',
  visible: 0, // 是否启用
  audit: ROOM_NEED_AUDIT.no, //审核类型(0.不需要[默认],1.需要)
  allowSvc: ROOM_ALLOW_SVC.no
};



// WEBPACK FOOTER //
// ./src/components/account/RoomEditor.js